import { FC, useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';
import EditShoppingListSidePanel from './EditShoppingListSidePanel';
import { ViewShoppingListsContext } from './ViewShoppingListsContext';

const EditShoppingListSidePanelContainer: FC = () => {
  const editingShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.editingShoppingList
  );
  const isEditShoppingListPanelOpen = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.isEditShoppingListPanelOpen
  );
  const closeEditShoppingListPanel = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.closeEditShoppingListPanel
  );

  const handleSaveSuccess = useCallback(() => {
    closeEditShoppingListPanel();
  }, [closeEditShoppingListPanel]);

  return (
    <EditShoppingListSidePanel
      isOpen={isEditShoppingListPanelOpen}
      shoppingList={editingShoppingList}
      onClose={closeEditShoppingListPanel}
      onSaveSuccess={handleSaveSuccess}
    />
  );
};

export default EditShoppingListSidePanelContainer;
